<template>
  <div class="row">
    <div class="col-6">
      <label>Przetopiony produkt</label>
      <v-select
        label="displayName"
        :options="availableMeltDownProducts"
        v-model="meltDownProductItem.meltDownProduct"
        :reduce="(x) => x"
      >
        <template slot="option" slot-scope="option">
          <div>
            <strong>{{ option.productName }}</strong> (Seria: {{ option.serialNumber }})
            <br />
            <small>Dostępne: {{ option.availableWeight }} kg | Przetopiono: {{ formatDate(option.meltDownDate) }}</small>
          </div>
        </template>
        <template slot="selected-option" slot-scope="option">
          {{ option.productName }} ({{ option.availableWeight }} kg)
        </template>
        <template slot="no-options"> Brak dostępnych przetop ionych produktów </template>
      </v-select>

      <div
        class="alert alert-danger"
        role="alert"
        v-if="!meltDownProductItem.meltDownProduct"
      >
        Wybierz przetopiony produkt
      </div>
    </div>

    <div class="col-5">
      <label>Ilość(kg) do użycia</label>
      <input
        type="number"
        class="form-control"
        step="0.001"
        v-model="weightSetter"
      />

      <div class="alert alert-danger" role="alert" v-if="errors.weight">
        Wpisana waga przekracza dostępną wagę lub jest nie prawidłowa
      </div>
    </div>
    <div class="col-1 buttons-col-area">
      <button
        type="button"
        class="btn btn-primary button-col"
        @click="RemoveItem"
      >
        Usuń
      </button>
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  props: ['meltDownProductItem', 'availableMeltDownProducts'],
  mixins: [],
  computed: {},
  watch: {
    weightSetter(weight) {
      this.errors.weight = false;
      if (this.meltDownProductItem.meltDownProduct) {
        if (weight > this.meltDownProductItem.meltDownProduct.availableWeight || weight < 0) {
          this.errors.weight = true;
        }
        this.meltDownProductItem.weight = parseFloat(weight);
      }
    },
    isValid() {
      this.isValid = !this.errors.weight && !this.errors.meltDownProduct;
    },
  },
  data() {
    return {
      weightSetter: 0,
      isValid: true,
      errors: {
        weight: false,
        meltDownProduct: false,
      },
    };
  },
  methods: {
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('pl-PL');
    },
    RemoveItem() {
      this.$emit('RemoveMeltDownProductItem', this.meltDownProductItem.id);
    },
  },
};
</script>
